// surfaceMaturity.js — maturidade EXPLÍCITA de cada workspace (P7). O núcleo
// Code+Chat+Plan é 'stable' (herda a confiabilidade do RunOutcome canônico + o
// connected-real); as telas mais novas ficam 'beta'/'experimental' com um badge
// discreto na aba, pra a UI não PROMETER o que ainda não entrega. FONTE ÚNICA —
// a aba (TopTabs) e qualquer gate futuro leem daqui. @arch:pure

/** @typedef {'stable'|'beta'|'experimental'} Maturity */

export const MATURITY = Object.freeze({
  code: 'stable',
  chat: 'stable',
  plan: 'stable',
  council: 'beta',
  god: 'experimental',
  hermes: 'experimental',
  dispatch: 'experimental',
});

/** Maturidade de um workspace (default 'stable' pra ids desconhecidos). */
export const maturityOf = (id) => MATURITY[id] || 'stable';

// Rótulo curto + título humano por nível. 'stable' não tem badge (limpo).
// Interno — a API pública é maturityBadge (ninguém importa o meta cru).
const MATURITY_META = Object.freeze({
  beta: { label: 'beta', title: 'Beta — em amadurecimento, pode ter arestas' },
  experimental: { label: 'exp', title: 'Experimental — pode mudar ou quebrar' },
});

/** Badge da aba: null p/ stable (sem selo), meta p/ beta/experimental. */
export const maturityBadge = (id) => MATURITY_META[maturityOf(id)] || null;
